import showBackStub from './showBackStub';

const minWidth = 800;
const minHeight = 419;

const checkScreenResolution = () => {

    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    if (currentWidth < minWidth || currentHeight < minHeight){
        showBackStub('resolution');
        return false;
    }

    showBackStub(false);
    return true;
};

export default checkScreenResolution;


// WEBPACK FOOTER //
// ./src/js/utils/checkScreenResolution.js